import { getMethodLogo } from "@/assets/methods";

/**
 * Toont het officiële merklogo van een betaalmethode in een witte chip.
 * Valt terug op een tekstbadge als er geen logo bekend is.
 */
export function MethodLogo({
  slug,
  name,
  size = "md",
  className = "",
}: {
  slug: string;
  name: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const logo = getMethodLogo(slug);
  const box =
    size === "lg"
      ? "h-14 px-5"
      : size === "sm"
        ? "h-8 px-2.5"
        : "h-10 px-3.5";
  const img = size === "lg" ? "h-8 max-w-28" : size === "sm" ? "h-4 max-w-16" : "h-6 max-w-24";

  if (!logo) {
    return (
      <span
        className={`inline-flex items-center rounded-md border border-border bg-white font-semibold text-foreground ${box} ${className}`}
      >
        {name}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center rounded-md border border-border bg-white shadow-sm ${box} ${className}`}
    >
      <img
        src={logo}
        alt={`${name} logo`}
        width={size === "lg" ? 112 : size === "sm" ? 64 : 96}
        height={size === "lg" ? 32 : size === "sm" ? 16 : 24}
        className={`${img} w-auto object-contain`}
        loading="lazy"
        decoding="async"
      />
    </span>
  );
}
